import React from 'react';
import { Badge } from '@wix/members-badge-lib';
import { classes, st } from './member-badge.st.css';
const MemberBadge = ({ badge, className, layout = 'name-icon' }) => {
    return (React.createElement("div", { className: st(classes.badge, className) },
        React.createElement(Badge, { badge: {
                ...badge,
                roleId: badge.roleId ?? '',
                textColor: badge.textColor ?? '',
                hasPermissions: false,
                backgroundColor: '',
            }, hideDefaultIcon: true, layout: layout, size: "tiny", font: "", background: true, borderRadius: 0, textStyle: { fontWeight: 'inherit', font: 'inherit', color: 'inherit' }, truncateTitle: true })));
};
export default MemberBadge;
//# sourceMappingURL=member-badge.js.map